import { Model, go } from 'oderon-vue'
// import moment from 'moment'
// import utils from 'oderon-commons/src/utils.js'
// import _ from 'lodash'

export const Camera = new Model('/cameras')
Camera.patch = (id, body) => go.patch(`/cameras/${id}`, body)
// Camera.findMailbox = (id, qs) => go.get(`/cameras/${id}/mailbox`, qs)
// Camera.findMailboxById = (cameraId, itemId, qs) =>
//   go.get(`/cameras/${cameraId}/mailbox/${itemId}`, qs)
// Camera.createMailbox = (id, body) => go.post(`/cameras/${id}/mailbox`, body)
// Camera.resendMailbox = (cameraId, itemId, body) =>
//   go.post(`/cameras/${cameraId}/mailbox/${itemId}/resend`, body)
// Camera.cancelMailbox = (cameraId, itemId, qs) =>
//   go.delete(`/cameras/${cameraId}/mailbox/${itemId}`, qs)

Camera.associate = (id, body) => go.post(`/cameras/${id}/association`, body)
Camera.dissociate = (id, ps) => go.delete(`/cameras/${id}/association`, ps)

Camera.findHistory = (id, ps) => go.get(`/cameras/${id}/history`, ps)

// O primeiro find verifica se o id do histórico corresponde
// ao da câmera (usado para garantia ao abrir/editar registro).
// O segundo só abre o registro pelo id (usado no histórico
// global de câmeras).
Camera.findHistoryById = (historyId, cameraId) => {
  if (cameraId != null) {
    return go.get(`/cameras/${cameraId}/history/${historyId}`)
  } else {
    return go.get(`/cameras/history/${historyId}`)
  }
}

Camera.saveHistory = (body) => {
  if (body.id)
    return go.put(`/cameras/${body.cameraId}/history/${body.id}`, body)
  else return go.post(`/cameras/${body.cameraId}/history`, body)
}

// Camera.findDailyStats = (id, ps) => go.get(`/cameras/${id}/stats`, ps)

// Camera.findVideoFiles = (ps) => go.get('/cameras/video-files', ps)
// Camera.findLocations = (ps) => go.get('/cameras/locations', ps)
// Camera.findAlarms = (ps) => go.get('/cameras/alarms', ps)

// Camera.findDailyLogStats = async ({
//   cameraId,
//   fromDate,
//   untilDate,
//   limit,
//   offset
// }) => {
//   await utils.delay(1000)
//   return randomdata({ fromDate, untilDate })
// }

// Camera.findDailyEventStats = async ({
//   cameraId,
//   fromDate,
//   untilDate,
//   limit,
//   offset
// }) => {
//   await utils.delay(1000)
//   return [] // randomdata({ fromDate, untilDate })
// }

// Camera.findLogs = async ({ cameraId, fromDate, untilDate, limit, offset }) => {
//   await utils.delay(1000)
//   let points = sampleLogs.rows
//     .filter((x) => x.path == '/pushgps')
//     .filter((x) => x.body.lat != 0 && x.body.lng != 0)
//     .map((x) => {
//       return {
//         lat: x.body.lat,
//         lng: x.body.lng,
//         time: moment.utc(x.gpsTime, 'YYYY-MM-DD HH:mm:ss')
//       }
//     })

//   return { rows: sampleLogs.rows, points }
// }

// Camera.findEvents = async ({
//   cameraId,
//   fromDate,
//   untilDate,
//   limit,
//   offset
// }) => {
//   await utils.delay(500)

//   let alarms = [...sampleAlarms]
//   let medias = [...sampleCameraFiles]

//   let points = sampleAlarms
//     .filter((x) => x.lat != null && x.lng != null)
//     .map((x) => {
//       return {
//         lat: x.lat,
//         lng: x.lng,
//         time: moment(x.timestamp)
//       }
//     })

//   return { alarms, medias, points }
// }

// function randomdata({ fromDate, untilDate }) {
//   let delta = moment(untilDate).diff(fromDate, 'days')

//   let result = []

//   for (let i = 0; i < 15; i++) {
//     let date = utils.sod(fromDate, _.random(0, delta))
//     result.push({
//       date: moment(date).format('YYYY-MM-DD'),
//       cssClass: _.sample(['level-1', 'level-2', 'level-3'])
//     })
//   }

//   console.log('randomdata for month %s', fromDate, result)

//   return result
// }

// Camera.findMini = (ps) => go.get(`/vehicles/mini`, ps)

// const exemplo = { id: 1, name: 'exemplo', label: 'Exemplo' }
// const vazante = { id: 39, name: 'vazante', label: 'Complexo Vazante' }
// const v121 = { id: 121, org: vazante, code: 'RTA-2A63' }
// const v14 = { id: 14, org: exemplo, code: 'TESTELAB' }
// const v7 = { id: 7, org: exemplo, code: 'FVN-9277' }

// const _cameras = [
//   {
//     id: 1,
//     imei: '0862798050426960',
//     name: 'C00 - Lab (Zé)',
//     org: exemplo,
//     vehicle: v7,
//     createdAt: moment('2024-01-01').toDate(),
//     updatedAt: moment('2024-01-02').toDate()
//   },
//   {
//     id: 2,
//     imei: '0862798051795116',
//     name: 'C01 - Lab (JV)',
//     org: exemplo,
//     vehicle: v14,
//     createdAt: moment('2024-01-03').toDate(),
//     updatedAt: moment('2024-01-04').toDate()
//   },
//   {
//     id: 3,
//     imei: '0862798051794275',
//     name: 'C02',
//     org: vazante,
//     vehicle: v121,
//     createdAt: moment('2024-01-05').toDate(),
//     updatedAt: moment('2024-01-06').toDate()
//   }
// ]

// const _mailboxItems = [
//   {
//     id: 137,
//     imei: '0862798051794275',
//     status: 'delivered',
//     commandStr: 'VERSION',
//     serverBit: 53,
//     replyStr:
//       '[VERSION]KMC28_JC400D_BSBA_CUST_V2.3.1_230509.1821,[BUILD]2023-0',
//     createdAt: '2024-03-15T15:17:46.000Z',
//     updatedAt: '2024-03-15T15:28:23.000Z'
//   },
//   {
//     id: 138,
//     imei: '0862798051794275',
//     status: 'delivered',
//     commandStr: 'DMS_SWITCH',
//     serverBit: 54,
//     replyStr: 'DMS_SWITCH:1 , 1 , 15',
//     createdAt: '2024-03-20T14:27:43.000Z',
//     updatedAt: '2024-03-20T15:27:15.000Z'
//   },
//   {
//     id: 139,
//     imei: '0862798051794275',
//     status: 'delivered',
//     commandStr: 'DMS_SWITCH,1,1,0',
//     serverBit: 55,
//     replyStr: 'OK!',
//     createdAt: '2024-03-20T20:09:48.000Z',
//     updatedAt: '2024-03-20T20:12:00.000Z'
//   },
//   {
//     id: 140,
//     imei: '0862798051794275',
//     status: 'delivered',
//     commandStr: 'DMS_CONTINUITY',
//     serverBit: 56,
//     replyStr: 'DMS_CONTINUITY:1  2  5  3  4  10',
//     createdAt: '2024-03-25T13:02:54.000Z',
//     updatedAt: '2024-03-25T13:05:56.000Z'
//   },
//   {
//     id: 141,
//     imei: '0862798051794275',
//     status: 'delivered',
//     commandStr: 'DMS_CONTINUITY,1,2,8,3,4,10',
//     serverBit: 57,
//     replyStr: 'OK!',
//     createdAt: '2024-03-25T13:39:13.000Z',
//     updatedAt: '2024-03-25T13:44:23.000Z'
//   }
// ].reverse()

// Camera.findAll = () => {
//   return { count: _cameras.length, rows: _cameras }
// }

// Camera.findById = (id) => _cameras.find((x) => x.id == id)

// Camera.findMailbox = ({ imei, limit, offset }) => {
//   console.log('fetching camera mailbox')
//   return { count: _mailboxItems.length, rows: _mailboxItems }
// }
